import React, { useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import Container from "react-bootstrap/Container";
import { getOrderByEmail } from "services/shopify-account";
import Loader from "components/loader";
import Order from "components/account/order";
import * as styles from "./style.mod.scss";
import locale from "locales";
import { loadRecaptcha } from "helpers/load-recaptcha";
import { shipmentTracking, trackError } from "helpers/analytics";

const OrderByEmail = ({ data }) => {
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [open, setOpen] = useState({});
  const [searchInfo, setSearchInfo] = useState({
    email: "",
    orderNumber: ""
  });

  let disabled = searchInfo.email === "" || searchInfo.orderNumber === "";

  const afterCaptcha = (callback) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(
        process.env.GATSBY_RECAPTCHA_SITE_KEY,
        { action: "submit" }
      ).then(callback);
    });
  };

  const getOrder = async () => {
    setLoading(true);
    const order = await getOrderByEmail(searchInfo);

    if (order) {
      setOrder(order);
      setErrorMsg(null);
      shipmentTracking();
    } else {
      setErrorMsg(`${locale.pages.contact.errorMsg}`);
      trackError(locale.pages.contact.errorMsg);
    }

    setLoading(false);
  };

  const fetchOrder = async () => {
    afterCaptcha(getOrder);
  };

  return <Container fluid style={{ backgroundColor: data.bgColor && data.bgColor.hex }}>
    <div className={styles.orderByEmailWrapper} >
      <h2 className={styles.title}>{data.title}</h2>

      <div className={styles.inputs}>
        <div className={styles.input}>
          <label>{locale.pages.contact.yourEmail}</label>
          <input type="email" onFocus={loadRecaptcha} onChange={(e) => setSearchInfo({
            ...searchInfo,
            email: e.target.value
          })}
          disabled={loading} />
        </div>
        <div className={styles.input}>
          <label>{locale.pages.contact.orderNr}</label>
          <input placeholder="#OL123456" type="text" onChange={(e) => setSearchInfo({
            ...searchInfo,
            orderNumber: e.target.value.replace("#", "")
          })}
          disabled={loading} />
          <span>{locale.pages.contact.findOrderNr}</span>
        </div>
        <button className={styles.button} disabled={disabled} onClick={fetchOrder}>{locale.pages.contact.trackOrder}</button>
      </div>
      {
        order && !errorMsg && !loading && (
          <Accordion className={styles.accordion} defaultActiveKey={order.id}>
            <Order order={order} setOpen={setOpen} open={open} standalone={true} alwaysOpen={true} />
          </Accordion>
        )
      }
      {
        errorMsg && !loading && (
          <span className={styles.errorMsg}>{errorMsg}</span>
        )
      }
    </div>
    {loading && <Loader color="white" width="100%" />}
  </Container>;
};

export default OrderByEmail;
